<template>
	<div class="ui dropdown item">
		<i class="translate icon"/>
		<span v-if="!isMobile">
			{{ currentLanguage }}
		</span>
		<i class="dropdown icon"/>
		<div class="menu">
			<a class="item" @click="selectLanguage('en')">
				{{ $t('components.languageselector.languages.english') }}
			</a>
			<a class="item" @click="selectLanguage('da')">
				{{ $t('components.languageselector.languages.danish') }}
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'LanguageSelector',

		data () {
			return {
				isMobile: false
			}
		},

		mounted () {
			this.$nextTick(() => {
				$(this.$el).dropdown()
			})

			this.$nextTick(function () {
				window.addEventListener('resize', () => {
					this.checkIfMobile()
				})

				this.checkIfMobile()
			})
		},

		computed: {
			currentLanguage () {
				let language = null
				switch (this.$root.$i18n.locale) {
					case 'en':
						language = this.$t('components.languageselector.languages.english')
						break
					case 'en-US':
						language = this.$t('components.languageselector.languages.english')
						break
					case 'da':
						language = this.$t('components.languageselector.languages.danish')
						break
					case 'da-DK':
						language = this.$t('components.languageselector.languages.danish')
						break
				}
				return language
			}
		},

		methods: {
			selectLanguage (lang) {
				this.$root.$i18n.locale = lang
				window.localStorage.language = lang

				// window.location.reload()
			},

			checkIfMobile () {
				this.isMobile = window.innerWidth <= 1200;
			}
		}
	}
</script>




// WEBPACK FOOTER //
// src/components/layout/LanguageSelector.vue